<template>
    <div v-if="stage">
        <div class="row">
            <!-- begin stage card -->
            <div class="col-xl-12 m-b-20">
                <b-card no-body class="overflow-hidden" bg-variant="dark" text-variant="light">
                    <b-row no-gutters>
                        <b-col md="2">
                            <b-card-img :src="getImage(stage.image)" alt="Image" class="rounded-0"></b-card-img>
                        </b-col>
                        <b-col md="10" class="p-0">
                            <b-card-body :title="stage.name">
                                <b-card-text>
                                    {{ stage.description }}
                                </b-card-text>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
            <!-- end stage card -->
        </div>
        <div class="row">
            <div class="col-xl-12 m-b-20">
                <!-- begin panel -->
                <panel no-button="true" title="Stage steps">
                    <storyboard-filter 
                        :items="this.filterSteps(stage.id)" 
                        :getImage="getImage"
                        :itemViewUrl="`/storyboard/${$route.params.id}/stage/`"
                        :addButton="{
                            'title': 'Add step',
                            'label': 'Add new step',
                            'url': `/storyboard/${$route.params.id}/stage/${stage.id}/step/new`
                        }"
                        :removeFromParent="removeStep"
                        :colsLength="3"
                        :perPage="11"
                    />
                </panel>
                <!-- end panel -->
            </div>
        </div>
        <!-- begin orphan steps panel -->
        <panel v-if="this.filterSteps(null).length" no-button="true" title="Add steps to stage">
            <storyboard-filter 
                :items="filterSteps(null)" 
                :getImage="getImage"
                :addToParent="addStep"
                :showStageFilter="false" 
                :colsLength="3"
                :perPage="12"
            />
        </panel>
        <!-- end orphan steps panel -->
        <b-card class="m-b-20" header-tag="header" header-bg-variant="dark" header-text-variant="light">
            <template v-slot:header>
                <h6 class="mb-0">Actions</h6>
            </template>
            <url-button class="btn-secondary" label="Back" :url="stage.storyboard ? `/storyboard/${stage.storyboard}/plan` : `/storyboard`" />
            <url-button class="btn-yellow pull-right" label="View" :url="`/storyboard/${stage.storyboard}/stage/${stage.id}`" />
        </b-card>
    </div>
</template>

<script>
import UrlButton from '../../components/buttons/UrlButton.vue'
//import InputButton from '../../components/buttons/InputButton.vue'
import StoryboardFilter from '../storyboard/StoryboardFilter.vue'

export default {
    name: 'StagePlan',
    props: ['stage', 'steps', 'storyboard', 'scriptItems'],
    components: {
        UrlButton, 
        //InputButton,
        StoryboardFilter
    },
    data() {
        return {
            sItems: []
        }
    },
    methods: {
        filterSteps(stageId) {
            return this.steps.filter(function(step) {
                return step.stage == stageId
            })
        },
        addStep(step) {
            if (confirm(`Add ${step.name} to ${this.stage.name}?`)) {
                this.$parent.$parent.stepEditStage(step.id, JSON.stringify({
                    stage: this.stage.id
                }));
                //this.$router.go();
            }
        },
        removeStep(step) {
            if (confirm(`Remove ${step.name} from ${this.stage.name}?`)) {
                this.$parent.$parent.stepEditStage(step.id, JSON.stringify({
                    stage: null
                }));
                //this.$router.go();
            }
        },
        getImage(image) {
            if (image == null) {
                return require('../../assets/images/no_image.jpg');
            } else {
                return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd;
            }
        },
        getTypeName(typeId) {
            switch (typeId) {
                case 1:
                    return 'service'
                case 2:
                    return 'space'
                case 3:
                    return 'staff'
                case 4:
                    return 'stuff'
                default:
                    return ''
            }
        },
        filterItems(stage) {
            if (stage) {
                let stepIds = [];
                stage.steps.forEach(step => {
                    stepIds.push(step.id);
                });
                let filteredItems = this.scriptItems.filter(sItem => {
                    if (stepIds.includes(sItem.step.id)) {
                        return sItem;
                    }
                });
                this.sItems = filteredItems;
            }
        },
        filterItemsByType(type) {
            return this.sItems.filter(sItem => {
                if (this.getTypeName(sItem.item.type) == type) {
                    return sItem;
                }
            });
        }
    },
    mounted() {
        this.filterItems(this.stage);
    },
    watch: {
        stage: function () {
            this.filterItems(this.stage);
        }
    }
}
</script>